import React from 'react'
import FixedTextTableData from '../../components/tableComponents/FixedTextTableData'
import VariableTextTableData from '../../components/tableComponents/VariableTextTableData'

const NewTableRow = ({ dataElement, setDataElement, pexEntries }) => {
	const pexData = dataElement.permissionData

	function updatePermissionData(attribute, value) {
		const dataCopy = { ...dataElement }
		dataCopy.permissionData[attribute] = value
		setDataElement(dataCopy)
	}

	function updateData(attribute, value) {
		setDataElement({ ...dataElement, [attribute]: value })
	}

	return (
		<tr>
			<FixedTextTableData text={''} />
			<VariableTextTableData
				text={dataElement.name}
				setText={(newText) => {
					updateData('name', newText)
				}}
			/>
			{pexEntries.map((value) => (
				<td key={value}>
					<input
						type='checkbox'
						checked={pexData[value]}
						onChange={() => {
							updatePermissionData(value, !pexData[value])
						}}
					/>
				</td>
			))}
		</tr>
	)
}

export default NewTableRow
